export default "__VITE_ASSET__bdgDOAYp__"